// src/components/PromptBar.js
import React, { useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'

const PromptBar = ({ prompt, rightPanelVisible }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  if (!prompt) return null

  const truncatedPrompt = prompt.length > 100 
    ? prompt.slice(0, 100) + '...'
    : prompt

  return (
    <div className={`bg-gray-800 border-b border-gray-700 px-4 transition-all z-20 ${
      isExpanded ? 'py-3' : 'h-8'
    } ${rightPanelVisible ? 'mr-80' : ''}`}>
      <div className="flex items-center">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="mr-2 p-1 text-gray-400 hover:text-white rounded hover:bg-gray-700"
        >
          {isExpanded ? (
            <ChevronUp size={16} />
          ) : (
            <ChevronDown size={16} />
          )}
        </button>
        <div className={`flex-1 text-sm text-gray-300 ${isExpanded ? '' : 'truncate'}`}>
          {!isExpanded && truncatedPrompt}
        </div>
      </div>
      
      {isExpanded && (
        <div className="mt-2 text-sm text-gray-300 whitespace-pre-wrap">
          <p className="select-text">{prompt}</p>
        </div>
      )}
    </div>
  )
}

export default PromptBar